export const CLIENT_VALIDATED_STATUS_DRAFT = "DRAFT";
export const CLIENT_VALIDATED_STATUS_PENDING = "PENDING";
export const CLIENT_VALIDATED_STATUS_CANCELED = "CANCELED";
export const CLIENT_VALIDATED_STATUS_VALIDATED = "VALIDATED";